<template>

  <div class="home">
    <figure class="image is-2by1 full">
      <img src="../assets/mesas.jpg" />
    </figure>
    <h1 class="title is-1 on-top">NOSOTROS</h1>
    <div class="columns is-centered is-mobile">
      <div class="column is-four-fifths">
        <div class="columns is-multiline">
          <div class="column is-three-quarters">
            <div class="part">
              <br />
              <br />
              <h1 class="title is-3">Origen:</h1>
              <i>Menuly</i> es un emprendimiento que nace durante la cuarentena por la pandemia del
              <b>Covid-19</b> buscando ayudar a los restaurantes a poder
              volver a operar sin poner en riesgo a sus clientes. Notamos que un importante foco de contagio pueden ser los menús en los restaurantes
              y encontramos la solución:
              <b>códigos QR</b>. En
              <i>Menuly</i> ofrecemos el diseño, la creación y el mantenimiento de códigos QR
              para que los restaurantes puedan ofrecer su menú sin tener contacto directo con sus clientes.
              <br />
              <br />Además, ofrecemos
              <b>
                <router-link to="/#servicios" class="light-blue">tres servicios</router-link>
              </b> para solucionar la problemática que se presenta en las 3 áreas que son prioridad
              en esta "nueva normalidad":
              <b>la salud, la eficiencia y el flujo económico.</b>
            </div>
            <br />
          </div>
          <div class="column is-one-quarter manos">
            <img src="../assets/manos.jpg" alt="Imagen higiene" />
          </div>
        </div>
      </div>
    </div>
    <section class="hero is-light">
      <div class="hero-body">
        <div class="columns is-centered is-mobile">
          <div class="column is-four-fifths">
            <div class="columns">
              <div class="column is-one-half">
                <h1 class="title is-3">Misión:</h1>
                <img src="../assets/quote.png" alt="'" class="quote"/>
                <br>Generar <b>confianza </b> los restaurantes y sus clientes
                usando la tecnología para que el ir a comer sea una experiencia más <b>rápida, saludable y sin riesgos.</b>
                <br><img src="../assets/quote.png" alt="'" class="flip quote"/><br>
              </div>
              <div class="column is-one-half">
                <img src="../assets/qrs.jpg" alt="Imagen tecnología" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-centered is-mobile">
        <div class="column centered">
          <div class="wide-separator-line"></div>
        </div>
      </div>
      <div class>
        <div class="columns is-centered is-mobile">
          <div class="column is-four-fifths">
            <div class="columns is-multiline">
              <div class="column is-one-half">
                <h1 class="title is-3">Visión:</h1>
                <img src="../assets/quote.png" alt="'" class="quote"/>
                <br>Ser la solución tecnológica número uno para
                <b>pago de cuentas eficiente e higiénico</b> en restaurantes de Latinoamérica.
                <br><img src="../assets/quote.png" alt="'" class="flip quote"/><br>
              </div>
              <div class="column is-one-half">
                <img src="../assets/vision.jpg" alt="vision" />
                <br id="servicios" />
              </div>
            </div>
          </div>
        </div>
        <br>
      </div>
    </section>
    <br />
    <br />
    <Servicios></Servicios>
    <br />
    <br />
    <Contacto id="contacto"></Contacto>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from "@/components/HelloWorld.vue";
import Servicios from "@/components/Servicios.vue";
import Contacto from "@/components/Contacto.vue";

export default {
  name: "home",
  components: {
    HelloWorld,
    Servicios: Servicios,
    Contacto: Contacto,
  },
};
</script>

<!-- SCSS -->
<style scoped lang="scss">
.logo {
  width: 400px;
}
.column {
  text-align: justify;
  padding-left: 5%;
  padding-right: 5%;
}
.part {
  a {
    &:hover {
      color: #9ed96b !important;
    }
  }
}
.full {
  height: 100%;
}
.on-top {
  position: absolute;
  top: 17%;
  color: white;
  left: 5%;
}
.manos {
  padding-left: 3%;
  padding-right: 3%;
  padding-top: 30px;
}
.quote {
  width: 10%;
}
.text-align-right {
  text-align: right;
}
.light-blue {
  color: #095168;
}
.wide-separator-line {
  height: 1px;
  background-color: #5c5b5b;
  margin: 5% 20px;
}
.flip{
    transform: scaleX(-1);
    float:right;
}

</style>
